<wiz-vgroup width="100%" height="100%" padding="0px">
  <wiz-vgroup #argsZone  width="100%" height="100%" style="display: flex; flex-wrap: wrap" wizOverflow="auto">
    <freegridster  
      [model]="model"
      width="100%" height="100%" 
      [widgets]="widgets">
  </freegridster>
  </wiz-vgroup>
</wiz-vgroup>
